import React from 'react'
import { motion } from "framer-motion"
import { useEase } from "../motion"

export const TitleCelebration = (props) => {

	const parentControl = {
		closed: {
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1,
			},
		},
		open: {
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1.5,
				delayChildren: 1.35,
				staggerChildren: 0.05,
				when: "afterChildren",
			},
		},
	}

	const letterVar = {
		closed: {
			scale: 0.3,
			rotate: -10,
			x: -6.76,
			y: -11.22,
			opacity: 0,
		},
		open: {
			scale: 1,
			rotate: 0,
			x: -6.76,
			y: -11.22,
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 0.75,
			},
		},
	}

   return (
		<div className="chapter-title">
			<motion.svg
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 418.25 47.4"
				variants={parentControl}
				initial="closed"
				animate={props.coverLoaded ? "open" : "closed"}
				exit="closed"
			>
				<defs>
					<clipPath id="clipPath" transform="translate(-6.76 -11.22)">
						<rect width="40" height="70" fill="none" />
					</clipPath>
					<clipPath
						id="clipPath-2"
						transform="translate(-6.76 -11.22)"
					>
						<rect x="46" width="122" height="72" fill="none" />
					</clipPath>
					<clipPath
						id="clipPath-3"
						transform="translate(-6.76 -11.22)"
					>
						<rect x="173" width="272" height="72" fill="none" />
					</clipPath>
				</defs>
				<g id="celebration" className="isolation">
					<g id="group_a">
						<g clipPath="url(#clipPath)">
							<g id="a">
								<motion.path
									variants={letterVar}
									d="M27.91,23.92h3.2V47.27h-3.2V42.42a10.67,10.67,0,0,1-9.45,5.45,12,12,0,0,1-11.7-12.3,11.92,11.92,0,0,1,11.8-12.25,10.49,10.49,0,0,1,9.35,5.15Zm0,11.75a9.21,9.21,0,0,0-9.1-9.3,9.23,9.23,0,1,0,9.1,9.3Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
							</g>
						</g>
					</g>
					<g id="group_quiet">
						<g clipPath="url(#clipPath-2)">
							<g id="quiet">
								<motion.path
									variants={letterVar}
									d="M71.76,23.92H75v34.7h-3.2V42.77a10.42,10.42,0,0,1-9.3,5.1A11.84,11.84,0,0,1,50.61,35.62a11.92,11.92,0,0,1,11.85-12.3,10.52,10.52,0,0,1,9.3,5.15Zm0,11.6a9,9,0,0,0-9.05-9.15,9.08,9.08,0,0,0-8.9,9.3,9,9,0,0,0,8.9,9.15A9.07,9.07,0,0,0,71.76,35.52Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M100.21,23.92h3.2V47.27h-3.2v-4.1c-1.4,3.3-5.2,4.7-8.1,4.7-5.65,0-9.5-3.9-9.45-10.35V23.92h3.2V37.47c0,4.5,2.8,7.35,6.6,7.35s7.7-2.2,7.75-7.85Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M110.56,15.32A2.49,2.49,0,1,1,113,17.57,2.35,2.35,0,0,1,110.56,15.32Zm.85,32V23.92h3.2V47.27Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M144.36,36.92h-20.1a8.35,8.35,0,0,0,8.75,7.9,8.77,8.77,0,0,0,7.6-4.1l2.75,1.2a11.73,11.73,0,0,1-10.45,5.95c-6.6,0-11.85-4.95-11.85-12.35s5.25-12.2,11.85-12.2,11.55,4.8,11.55,12.2A13.18,13.18,0,0,1,144.36,36.92Zm-3.1-2.75c-.45-4.85-3.8-7.8-8.35-7.8s-8,2.8-8.6,7.8Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M160.46,23.92v2.75h-5.35v20.6H152V26.67h-4.25V23.92H152V15.17h3.15v8.75Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
							</g>
						</g>
					</g>
					<g id="group_celebration">
						<g clipPath="url(#clipPath-3)">
							<g id="celebration-2">
								<motion.path
									variants={letterVar}
									d="M176.41,35.57c0-7.4,5.7-12.25,12.4-12.25a12.16,12.16,0,0,1,8.35,3.2l-1.95,2.2a9.4,9.4,0,0,0-6.3-2.35,9,9,0,0,0-9.3,9.2,9.06,9.06,0,0,0,9.3,9.25,9.5,9.5,0,0,0,6.3-2.35l2,2.2a12.46,12.46,0,0,1-20.8-9.1Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M224.16,36.92h-20.1a8.35,8.35,0,0,0,8.75,7.9,8.77,8.77,0,0,0,7.6-4.1l2.75,1.2a11.73,11.73,0,0,1-10.45,5.95c-6.6,0-11.85-4.95-11.85-12.35s5.25-12.2,11.85-12.2,11.55,4.8,11.55,12.2A13.18,13.18,0,0,1,224.16,36.92Zm-3.1-2.75c-.45-4.85-3.8-7.8-8.35-7.8s-8,2.8-8.6,7.8Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M230.51,47.27V11.22h3.2V47.27Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M263.46,36.92h-20.1a8.35,8.35,0,0,0,8.75,7.9,8.77,8.77,0,0,0,7.6-4.1l2.75,1.2A11.73,11.73,0,0,1,252,47.87c-6.6,0-11.85-4.95-11.85-12.35s5.25-12.2,11.85-12.2,11.55,4.8,11.55,12.2A13.18,13.18,0,0,1,263.46,36.92Zm-3.1-2.75c-.45-4.85-3.8-7.8-8.35-7.8s-7.95,2.8-8.6,7.8Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M294.16,35.57c0,7.1-5.3,12.3-11.85,12.3a10.51,10.51,0,0,1-9.3-5.2v4.6h-3.2V11.22H273V28.47a10.47,10.47,0,0,1,9.3-5.15A11.84,11.84,0,0,1,294.16,35.57Zm-3.15,0a9,9,0,1,0-18,.15,9,9,0,0,0,9.05,9.15A9.09,9.09,0,0,0,291,35.52Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M314.81,24l-.6,3.05a8.22,8.22,0,0,0-3.15-.65c-5.55,0-7.25,6.3-7.25,12v8.8h-3.25V23.92h3.25v5.7c1.15-3.95,3.65-6.3,7.3-6.3A9.21,9.21,0,0,1,314.81,24Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M337.56,23.92h3.2V47.27h-3.2V42.42a10.67,10.67,0,0,1-9.45,5.45,12,12,0,0,1-11.7-12.3,11.92,11.92,0,0,1,11.8-12.25,10.49,10.49,0,0,1,9.35,5.15Zm0,11.75a9,9,0,1,0-9.05,9.15A9.07,9.07,0,0,0,337.56,35.67Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M358.86,23.92v2.75h-5.35v20.6h-3.15V26.67h-4.25V23.92h4.25V15.17h3.15v8.75Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M363,15.32a2.49,2.49,0,1,1,2.45,2.25A2.35,2.35,0,0,1,363,15.32Zm.85,32V23.92H367V47.27Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M373.41,35.57a12.23,12.23,0,1,1,24.45,0,12.23,12.23,0,1,1-24.45,0Zm21.25,0a9,9,0,1,0-18.05,0,9,9,0,1,0,18.05,0Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M425,33.67v13.6h-3.2V33.82c0-4.5-2.85-7.35-6.6-7.35s-7.7,2.2-7.8,7.85v13h-3.2V23.92h3.2v4.2c1.4-3.35,5.2-4.8,8.1-4.8C421.16,23.32,425,27.22,425,33.67Z"
									transform="translate(-6.76 -11.22)"
									fill="currentColor"
								/>
							</g>
						</g>
					</g>
				</g>
			</motion.svg>
		</div>
   )
}